'use client'

import AmplitudeProvider from '@eversports/amplitude-react/AmplitudeProvider'

export default function CustomAmplitudeProvider({ children }: { children: React.ReactNode }) {
  return (
    <AmplitudeProvider amplitudeProjectApiKey={process.env.NEXT_PUBLIC_AMPLITUDE_PROJECT_API_KEY}>
      {children}
    </AmplitudeProvider>
  )
}
